import {IDocument} from "../../../../core/interfaces/document";
import {CustomDropdownItem} from "../../../../components/CustomDropdown/CustomDropdownItem/CustomDropdownItem";
import {Icon} from "../../../../assets/Icons/IconClassNames";
import {PublishStatusType} from "../../../../core/enums/enums";
import {usePrivateTemplate, usePublishTemplate} from "../../../../api/TemplateApi";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../../../store/hooks";
import {addToast} from "../../../../store/slices/uiSlice";
import {toastInfo} from "../../../../core/helpers/toastHelper";

export const TogglePublishTemplate = (
    {
        document,
        isEditMode,
    }: { document: IDocument, isEditMode: boolean }) => {
    const dispatch = useAppDispatch();
    const [publishTemplate, isPublishingTemplate] = usePublishTemplate(document.id, document.name);

    const [isPublished, setPublished] = useState(PublishStatusType.APPROVED === document.publishStatus);

    useEffect(() => {
        setPublished(PublishStatusType.APPROVED === document.publishStatus);
    }, [document.publishStatus]);

    const handlePublishStatus = async () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        const request = {publish: !isPublished};
        await publishTemplate(request);
    }

    return <CustomDropdownItem
        icon={isPublished ? Icon.EYE_SLASH : Icon.EYE}
        text={isPublished ? "Avpublicera mall" : "Publicera mall"}
        disabled={isPublishingTemplate}
        onClick={handlePublishStatus}
    />
};

export const TogglePrivateTemplate = (
    {
        document,
        isEditMode,
    }: { document: IDocument, isEditMode: boolean }) => {
    const dispatch = useAppDispatch();
    const [privateTemplate, isLoading] = usePrivateTemplate(document.template?.id ?? "", document.id ?? "");

    const [isPrivate, setPrivate] = useState<boolean>(document.template?.private ?? true);

    useEffect(() => {
        if (document.template) {
            setPrivate(document.template.private);
        }
    }, [document.template]);

    const handleSetPrivate = async () => {
        if (isEditMode) {
            dispatch(addToast(toastInfo("Lämna redigeringsläge", "Vänligen lämna redigeringsläget.")));
            return;
        }
        const request = {private: !isPrivate};
        await privateTemplate(request);
    }
    return <CustomDropdownItem
        icon={isPrivate ? Icon.EYE : Icon.EYE_SLASH}
        text={isPrivate ? "Gör tillgänglig för företag" : "Gör tillgänglig enbart för SAMG"}
        disabled={isLoading}
        onClick={handleSetPrivate}
    />
}